
<div class="mt-4">
  <p class="text-body-2 text-grey-body mb-16">{{ statusMessage }}</p>
  <div class="flex flex-wrap gap-4">
    <cpr-badge :active="isBadgeComplete('cpr_certified')" :width="badgeSize" :height="badgeSize" :hasSimpleLabel="true" />
    <first-aid-badge
      :active="isBadgeComplete('first_aid_training')"
      :width="badgeSize"
      :height="badgeSize"
      :hasSimpleLabel="true"
    />
  </div>
</div>
